"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JGraphVerticalAxis = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ChartContext_1 = require("../../context/ChartContext");
const LinearVerticalAxis_1 = require("../../elements/linearAxis/LinearVerticalAxis");
const JGraphContext_1 = require("./JGraphContext");
function JGraphVerticalAxis() {
    const { width, margin } = (0, ChartContext_1.useChartData)();
    const { height, scaleY } = (0, JGraphContext_1.useJGraph)();
    if (!scaleY)
        return null;
    return ((0, jsx_runtime_1.jsx)("svg", { style: { overflow: 'visible' }, height: height + 20, width: 60, children: (0, jsx_runtime_1.jsx)(LinearVerticalAxis_1.LinearVerticalAxis, { x: 20, y: 0, scale: scaleY, height: height, showGrid: true, width: width - margin.right }) }));
}
exports.JGraphVerticalAxis = JGraphVerticalAxis;
